import { Editor } from 'grapesjs';
import { Feature } from '@loyalty/shared-common';
import { InteractionsListRenderer } from '@loyalty/editor-components';
import { faReceipt } from '@fortawesome/pro-solid-svg-icons/faReceipt';
import { EditorComponentDefinition } from '../types';
import { EditorContext } from '../../../services/editor-service';
import {
  InteractionsListWidgetTraits,
  interactionsListWidgetTraitsSchema,
} from './InteractionsListWidgetTraits';
import { buildParticipantContextFromGrape } from '../../utils';

export const interactionsListComponentDefinition: EditorComponentDefinition = {
  id: 'interactions-list',
  icon: faReceipt,
  category: 'Profile',
  getLabel: ({ t }) => t('editor.component.interactions-list'),
  component: InteractionsListComponent,
  traits: {
    schema: interactionsListWidgetTraitsSchema,
    form: InteractionsListWidgetTraits,
  },
  isEnabled: features => features[Feature.INTERACTION].read,
};

export function InteractionsListComponent(editor: Editor) {
  const i18n = editor.I18n;
  const context: EditorContext = editor.Config.context;

  editor.DomComponents.addType(interactionsListComponentDefinition.id, {
    model: {
      defaults: {
        attributes: {
          interactionIds: [],
          showLabel: false,
        },
        name: 'interactions-list',
        droppable: false,
        draggable: '[data-gjs-type=column]',
        traits: [],
      },
      toHTML(): string {
        return InteractionsListRenderer(
          {
            state: context.widgetState,
            options: {
              id: this.getId(),
              attributes: this.getAttributes(),
              i18nAttributes: this.attributes.i18nAttributes || {},
            },
            context: buildParticipantContextFromGrape(i18n),
          },
          editor.Canvas.getDocument(),
        );
      },
    },
    view: {
      onRender() {
        const { el, model } = this;
        el.innerHTML = model.toHTML();
      },
    },
  });
}
